var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 44.9999C34.9263 44.9999 44.9999 34.9263 44.9999 22.5C44.9999 10.0736 34.9263 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9263 10.0736 44.9999 22.5 44.9999Z",
    fill: "#FFC10E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8662 33.6217C27.578 27.2014 17.3207 27.2281 11.0691 33.6884C10.2726 34.5113 11.5275 35.769 12.325 34.9443C17.9147 29.1685 26.9839 29.133 32.6102 34.8776C33.4128 35.6973 34.668 34.4402 33.8662 33.6217Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6606 18.2729C17.6122 18.2729 19.1942 16.6908 19.1942 14.7392C19.1942 12.7876 17.6122 11.2056 15.6606 11.2056C13.709 11.2056 12.127 12.7876 12.127 14.7392C12.127 16.6908 13.709 18.2729 15.6606 18.2729Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0239 18.2729C30.9755 18.2729 32.5575 16.6908 32.5575 14.7392C32.5575 12.7876 30.9755 11.2056 29.0239 11.2056C27.0723 11.2056 25.4902 12.7876 25.4902 14.7392C25.4902 16.6908 27.0723 18.2729 29.0239 18.2729Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.cb103d13ef7846b20cbaf78aff9c645c.svg";
export { ForwardRef as ReactComponent };